import React from 'react';
import { useTranslation } from 'react-i18next';
import { timesheetsStatuses } from '../../../../utils/constants';
import classes from './StatusLabel.module.scss';

export default function StatusLabel({ type, isApprover }) {
  const { t } = useTranslation();

  return (
    <p
      className={classes.container}
      style={{ backgroundColor: timesheetsStatuses(t)[type]?.color, color: timesheetsStatuses(t)[type]?.textColor }}
    >
      {timesheetsStatuses(t, isApprover)[type]?.label}
    </p>
  );
}
